import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

export const referenceDataFilterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
}